import {
  Armchair,
  BarChart3,
  Boxes,
  Building2,
  Calendar,
  Contact,
  Gift,
  Globe,
  Landmark,
  Layers,
  LayoutDashboard,
  MapPin,
  Package,
  Receipt,
  Scissors,
  ScrollText,
  Settings2,
  Upload,
  Users,
  Wallet,
  Zap,
} from 'lucide-react'

/** @type {Record<string, import('lucide-react').LucideIcon>} */
export const NAV_ICONS = {
  'layout-dashboard': LayoutDashboard,
  calendar: Calendar,
  globe: Globe,
  receipt: Receipt,
  contact: Contact,
  users: Users,
  'bar-chart': BarChart3,
  boxes: Boxes,
  landmark: Landmark,
  building: Building2,
  'map-pin': MapPin,
  'scroll-text': ScrollText,
  layers: Layers,
  scissors: Scissors,
  armchair: Armchair,
  gift: Gift,
  package: Package,
  settings: Settings2,
  zap: Zap,
  upload: Upload,
  wallet: Wallet,
}

/**
 * @param {string} name
 */
export function getNavIcon(name) {
  return NAV_ICONS[name] ?? LayoutDashboard
}
